export default {"src":"/_next/static/media/preview.307bcf55.svg","height":780,"width":575,"blurWidth":0,"blurHeight":0};